import { Component, OnInit, ViewChild } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import Swal from 'sweetalert2'
declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

import { Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { Iec } from 'model/modal-cms/iec';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/admin';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { Infra } from 'model/modal-cms/infra';


@Component({
  selector: 'app-iec',
  templateUrl: './iec.component.html',
  styleUrls: ['./iec.component.scss']
})
export class IecComponent implements OnInit {
  loginuserCMSActuel: any;
  mode_ajout: number;
  nbr_covid19: any;
  date_covid19: Date;
  mode_cherche: number=1;
  infoIecPDF: any;
  motCleGeneral: any;
  infoIecImage: any;
  infoIecImageDes: any;
  motCle(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  @ViewChild('popup5') popup5: Popup;
    @ViewChild('popupArticle') popupArticle: Popup;

  @ViewChild('popupImageCMS') popupImageCMS: Popup;
  

  titre:any ="Coronavirus";
  date_video:any ="7 février 2020";
  source_video : any;
  @ViewChild('popup') popup: Popup;
  @ViewChild('popupmodif5') popupmodif5: Popup;
  infra: Infra = new Infra(null)
  epidemimie: Epidemimie = new Epidemimie(null)
  
  
  infoIec: any;  
  iec: Iec = new Iec(null);
  imageUrl: string = "logo_video2.png";
  urlphoto: string = "http://localhost/ImageEtudiant/upload";

  urllogoIec = environment.urllogoIec;
  urlfileIec = environment.urlfileIec;
  urlVideoIec= environment.urlVideoIec;
  
  fileToUmpload: File = null;
  fileToUmploadFichier: File = null;
  fileToUmploadImage: File = null;
  seleCtedFile: any;
  urlServer = environment.urlServerphoto;
  infoIecVideo: any;
  default_logo: any = "logo_actualite.jpg";
  logovideodefault: any = "logo_video2.png";

  statistique_actu : any;

  constructor(private router: Router, public cmsService: CMSService, private adminService: AdminService, private http: HttpClient, ) {
    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    if(this.loginuserCMSActuel=="com_daf"){
     this.mode_ajout=1;
    }else{
      this.mode_ajout=11;
    }
   }

  ngOnInit() {
    this.setDefaultVideo();
    this.getIecVideo();
    this.getIecFile();
    //this.getinfoipdemie();
    this.getIecFilePDFImage();
  }

  setDefaultVideo(){    
  let etat="E_ACTU"
  this.cmsService.getDefaultVideo(etat)
    .subscribe(data => { 
    console.log("data.fichier_iec"+data.fichier_iec);          
      this.source_video = data.fichier_iec     
    },
      err => {
        console.log(err);
      })
}
  
popupnew() {
  this.popup.options = {    
    cancleBtnClass: "btn btn-default",
    confirmBtnClass: "btn btn-danger",
    color: "#FF0000",
    showButtons: true,
    animationDuration: 2,
    header: "ALERT COVID-19",
    widthProsentage: 50,
    animation: "fadeInUp",
    confirmBtnContent: "En savoir plus",
    cancleBtnContent: "Fermer",
  }

  this.popup.show(this.popup.options);
 // this.getinfoipdemie();
}

getinfoipdemie() {
  let etat="ACTU"
  this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
    .subscribe(data => {           
      this.epidemimie = data
      this.nbr_covid19 =  this.epidemimie.text_epid 
      this.date_covid19 =  this.epidemimie.date_ajout 
      if(this.epidemimie.image_actu == null){
        this.statistique_actu = "alerte_corona.PNG";
        this.popupnew();         
      }else{
        this.statistique_actu = this.epidemimie.image_actu;
        this.popupnew();
      }
    },
      err => {
        console.log(err);
      })
}


  getIecFile() {
    this.cmsService.getIec("F")
      .subscribe(data => {
        this.infoIec = data
      },
        err => {
          console.log(err);
        })
  }

  rechercheIec(mcl){
    if(mcl==""){
      this.getIecFile();
    }else {
      this.cmsService.getIecParmocle(mcl)
      .subscribe(data => {
        this.infoIec = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  getIecVideo() {
    this.cmsService.getIec("V")
      .subscribe(data => {
        this.infoIecVideo = data
      },
        err => {
          console.log(err);
        })
  }

  getIecImage() {
    this.cmsService.getIecImage("P")
      .subscribe(data => {
        this.infoIecImage = data
      },
        err => {
          console.log(err);
        })
  }

  getIecImageDes() {
    this.cmsService.getDesafection("D")
      .subscribe(data => {
        this.infoIecImageDes = data
      },
        err => {
          console.log(err);
        })
  }

  

  rechercheIECVideo(motCle){

    if(motCle==""){
      this.getIecFile();
    }else {
      this.cmsService.getIecParmocle(motCle)
      .subscribe(data => {
        this.infoIecVideo = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  

  getInfoIEC_(id_iec:number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.Ajouter_();
      },
        err => {
          console.log(err);
        })
  }


  getInfoIEC(id_iec:number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.Ajouter();
      },
        err => {
          console.log(err);
        })
  }
  
  ///vahatra *106*0336499869#


    //upload  file etudiant
    onChangeSelectFile(file: FileList) {
      this.fileToUmpload = file.item(0);
      console.log(this.fileToUmpload);
      //show image preview
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUmpload);
     // this.mode_add = 1
     // this.selectImage = 2
    }


      //upload  file iec
      onChangeSelectFichier(file: FileList) {
        this.fileToUmploadFichier = file.item(0);
        console.log(this.fileToUmploadFichier);
        //show image preview
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUmploadFichier);
       // this.mode_add = 1
       // this.selectImage = 2
      }


       //upload  image iec
       onChangeSelectImage(file: FileList) {
        this.fileToUmploadImage = file.item(0);
        console.log(this.fileToUmploadImage);
        //show image preview
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUmploadImage);
       // this.mode_add = 1
       // this.selectImage = 2
      }
    
    onChangeSelectFile2(event) {
      this.seleCtedFile = event.target.files[0];
      console.log(this.seleCtedFile);
      }



      
   //uplod logo IEC
   enregistrerFileIEC() {   
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmpload, this.fileToUmpload.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer +'uploadPhotoIEC.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }

  //uplod fichier iec
  enregistrerFichierIEC() {   
    const uploadDataichierIEC = new FormData();
    uploadDataichierIEC.append('avatar', this.fileToUmploadFichier, this.fileToUmploadFichier.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer +'uploadFichierIEC.php', uploadDataichierIEC, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }


  //uplod image CMS
  enregistrerImageCMS() {   
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmploadImage, this.fileToUmploadImage.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer +'uploadImageCMS.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }


 
  AjouterIEC(){   
    if (this.iec.id_iec == null) {
       this.iec.logo_iec = this.fileToUmpload.name
       this.iec.fichier_iec= this.fileToUmploadFichier.name
    //  this.iec.etat_iec = "A";      
      this.cmsService.saveIec(this.iec).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           this.enregistrerFileIEC();
           this.enregistrerFichierIEC();
           this.getIecFile();
           this.getIecVideo();
           this.iec = new Iec(null)
           success_message.show();
           this.popup5.hide();
         },err=>{   
         })
    }else{

      if(this.fileToUmpload==null || this.fileToUmploadFichier ==null )  {
       
         }else{
           this.iec.logo_iec = this.fileToUmpload.name
           this.iec.fichier_iec= this.fileToUmploadFichier.name
           this.enregistrerFileIEC();
           this.enregistrerFichierIEC();
         }
      this.cmsService.updateIec(this.iec).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         } 
          this.getIecFile();
         this.getIecVideo();
         this.iec = new Iec(null)
         success_message.show();
         this.popup5.hide();
         this.popupmodif5.hide();
         this.chercherGeneralVideo();
         this.getIecFilePDFImage();
        
         
         },err=>{   
         })
    }
    
  }


  DeleteIec(r: Iec) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIec(r.id_iec)
        .subscribe(data => {
          this.getIecFile();
          this.getIecFilePDFImage();         
          this.chercherGeneralVideo();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }
 

 DeleteIecV(r: Iec) {
  Swal.fire({
    title: 'Êtes-vous sûr de supprimer?',
    text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'OK',
    cancelButtonText: 'Non'
  }).then((result) => {
    if (result.value) {
      this.cmsService.deleteIec(r.id_iec)
      .subscribe(data => {
        this.getIecVideo();
        success_message.show();
      }, err => {
        console.log('erreur de supression');
      })
    }
  })
}



  details(id:any,f:any){
    if(id == 1 || id == 41 ){
      this.router.navigate(['iec-epidemie']); 
    }else if(id==145){
      this.router.navigate(['geste-barr']);
    }else{
      this.router.navigate(['detail-iec/'+id+"/"+f]);   
    }
   
  }

  voir(){    
   if(this.adminService.getLoginUseCMS() == "com_daf"){
       this.router.navigate(['iec-epidemie']);
    }else{
     
       this.router.navigate(['landing']);
    }
  }

  

  Ajouter_() {
    this.popupmodif5.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Modifier information en cours ",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }

    this.popupmodif5.show(this.popupmodif5.options);
  }



 
  

   AjouterArticle() {
    this.popupArticle.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter article",
      widthProsentage: 50,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }
    this.popupArticle.show(this.popupArticle.options);
  }


 Ajouter() {
    this.popup5.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter information en cours ",
      widthProsentage: 50,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }
    this.popup5.show(this.popup5.options);
  }



  AjouterImage(){
    this.popupImageCMS.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter image",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }
    this.popupImageCMS.show(this.popupImageCMS.options);

  }

  
  AjouterImageIEC(){   
    if (this.infra.id_infra == null) {
       this.infra.image_infra = this.fileToUmploadImage.name
    this.cmsService.saveIecImage(this.infra).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           this.enregistrerImageCMS();           
           this.infra = new Infra(null)
           success_message.show();
           this.popupImageCMS.hide();
           this.getIecImage();
         },err=>{   
         })
    }else{
      if(this.fileToUmploadImage==null || this.fileToUmploadFichier ==null)  {
       
         }else{
           this.infra.image_infra = this.fileToUmploadImage.name;
           this.enregistrerImageCMS();
         }
      this.cmsService.updateIecImage(this.infra).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         } 
      
         this.infra = new Infra(null)
         success_message.show();
         this.popupImageCMS.hide(); 
            this.getIecImage();       
         },err=>{   
         })
    }
    
  }

  
  getInfoImage_(id_iec:number) {
    this.cmsService.getInfoImage(id_iec)
      .subscribe(data => {
        this.infra = data
        this.AjouterImage();
      },
        err => {
          console.log(err);
        })
  }


  DeleteImage(i: Infra) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIecImage(i.id_infra)
        .subscribe(data => {
          this.getIecImage();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }







  openVideo(id_vid:any,v:any){
    this.router.navigate(['detail-iec/'+id_vid+"/"+v]);   
  }


  getIecFilePDFImage_() {
    this.cmsService.getIecPDF("F")
      .subscribe(data => {
        this.infoIecPDF = data
      },
        err => {
          console.log(err);
        })
  }


  getIecFilePDFImage() {
    this.cmsService.getIecAllFichier()
      .subscribe(data => {
        this.infoIecPDF = data
      },
        err => {
          console.log(err);
        })
  }




  chercherGeneral(){
    console.log(this.motCleGeneral)
    if(this.motCleGeneral==""){
      this.getIecFilePDFImage();
    }else {
      this.cmsService.getIecParmocle(this.motCleGeneral)
      .subscribe(data => {
        this.infoIecPDF = data
      },
        err => {
          console.log(err);
        })
    }
    
  }


  chercherGeneralVideo(){
    console.log(this.motCleGeneral)
    if(this.motCleGeneral==""){
      this.getIecVideo();
    }else {
      this.cmsService.getIecParmocle(this.motCleGeneral)
      .subscribe(data => {
        this.infoIecVideo = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  //update 17/11/2021
  GetAllArticle(){
     this.mode_cherche=5
   // this.getIecArticle();
  }

  VoirFile(){
    
     this.router.navigate(['article']);
  }

  GetAllFichier(){
    this.mode_cherche=1
    this.getIecFilePDFImage();
  }



  GetAllVideo(){
    this.mode_cherche=2
    this.getIecVideo();
  }
  

  GetAllImage(){
    this.mode_cherche=3
    this.getIecImage();
  }


  GetAllImageDes(){
    this.mode_cherche=4
    this.getIecImageDes();
  }



  DeleteIecPDF(r: Iec) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIec(r.id_iec)
        .subscribe(data => {
          this.getIecFilePDFImage();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }


}
